// extracted by mini-css-extract-plugin
export default {"giftOrPromoRowWrapper":"ks-z","giftOrPromoSelector":"ls-z","disabled":"ms-z","subTitle":"ns-z","selectShipAddressMessage":"os-z","changePayment":"ps-z"};